import PropTypes from "prop-types";

export const connectionPropType = PropTypes.shape({
  id: PropTypes.string,
  kind: PropTypes.string,
});

export const pairingPropType = PropTypes.shape({
  qr_payload: PropTypes.string,
  expires_at: PropTypes.string,
  qr_code_url: PropTypes.string,
  pairing_code: PropTypes.string,
  instructions: PropTypes.string,
});

export const quoraConfigurePropType = PropTypes.shape({
  profileUrl: PropTypes.string.isRequired,
  setProfileUrl: PropTypes.func.isRequired,
  displayName: PropTypes.string.isRequired,
  setDisplayName: PropTypes.func.isRequired,
  connectBusy: PropTypes.bool.isRequired,
  error: PropTypes.string,
  profileValid: PropTypes.bool.isRequired,
  nameValid: PropTypes.bool.isRequired,
  connect: PropTypes.func.isRequired,
});

export const telegramConfigurePropType = PropTypes.shape({
  token: PropTypes.string.isRequired,
  setToken: PropTypes.func.isRequired,
  botName: PropTypes.string.isRequired,
  setBotName: PropTypes.func.isRequired,
  botUsername: PropTypes.string.isRequired,
  setBotUsername: PropTypes.func.isRequired,
  webhookUrl: PropTypes.string.isRequired,
  setWebhookUrl: PropTypes.func.isRequired,
  validated: PropTypes.bool.isRequired,
  error: PropTypes.string,
  testBusy: PropTypes.bool.isRequired,
  connectBusy: PropTypes.bool.isRequired,
  busy: PropTypes.bool.isRequired,
  tokenValid: PropTypes.bool.isRequired,
  testConnection: PropTypes.func.isRequired,
  connectTelegram: PropTypes.func.isRequired,
  resetValidation: PropTypes.func.isRequired,
});

export const mobilePlatformMetaPropType = PropTypes.shape({
  channelId: PropTypes.string.isRequired,
  platformLabel: PropTypes.string.isRequired,
  cameraApp: PropTypes.string.isRequired,
  storeName: PropTypes.string.isRequired,
  pingDotClass: PropTypes.string.isRequired,
  codeBadgeClass: PropTypes.string.isRequired,
  hintBoxClass: PropTypes.string.isRequired,
  spinnerBgClass: PropTypes.string.isRequired,
  spinnerIconClass: PropTypes.string.isRequired,
  device: PropTypes.string.isRequired,
  battery: PropTypes.number.isRequired,
  network: PropTypes.string.isRequired,
  successTitle: PropTypes.string.isRequired,
  completeLabel: PropTypes.string.isRequired,
});

export const oauthSuccessPatchPropType = PropTypes.shape({
  label: PropTypes.string,
  identity: PropTypes.string,
  successBlurb: PropTypes.string,
  inboxScope: PropTypes.string,
  messagesToday: PropTypes.number,
});
